import React from 'react';

function IcFilter() {
  return (
    <svg
      width='12'
      height='8'
      viewBox='0 0 12 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.29974 7.89998L0.566406 4.16665L1.28307 3.44998L4.29974 6.46665L10.6997 0.0666504L11.4164 0.783317L4.29974 7.89998Z'
        fill='#2C3232'
      />
    </svg>
  );
}

export default IcFilter;
